export default __webpack_public_path__ + "static/media/HeroImageSeguros.77f8beda.png";